// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wBMO","col":"styles_col__1LoNX"};